export const state = () => (require('@pleinair/bigcolony-vue/store/checkout/_state')())
export const mutations = require('@pleinair/bigcolony-vue/store/checkout/_mutations')
export const actions = require('@pleinair/bigcolony-vue/store/checkout/_actions')